// extracted by mini-css-extract-plugin
export default {"container":"TsAndCs_container__ShkLq","leftAlign":"TsAndCs_leftAlign__PVVs6","tC":"TsAndCs_tC__1LtAy"};